import SliderRange from '@/lib/SliderRange'

const DEFAULTS = {
	max: 40,
	stops: [
		{ min: 0, data: 'Never' },
		{ min: 1, data: 'Rarely' },
		{ min: 11, data: 'Occasionally' },
		{ min: 21, data: 'Frequently' },
		{ min: 31, data: 'Very frequently' }
	]
}

export default function(data) {
	return {
		data() {
			return {
				sliders: data.map(slider => {
					const { title, max, stops } = { ...DEFAULTS, ...slider }
					return new SliderRange(title, max, stops)
				})
			}
		},
		computed: {
			slidersTotal() {
				return this.sliders.reduce((tot, { value }) => tot + value, 0)
			}
		},
		watch: {
			slidersTotal(value) {
				this.$emit('input', value)
			}
		}
	}
}
